// Past these limits browsers fail silently: `toDataURL` returns 'data:,'
// instead of throwing. 2^25 px fits an A0 page at scale 2, so pages up to A0
// keep their requested scale and their crop coordinates.
const MAX_CANVAS_AREA = 2 ** 25
const MAX_CANVAS_SIDE = 16384

/**
 * The largest scale, up to `requestedScale`, at which a page of `pageSize`
 * (its size at scale 1) still fits a browser canvas.
 */
export const fitPdfRenderScale = (
  pageSize: { width: number; height: number },
  requestedScale: number
): number =>
  Math.min(
    requestedScale,
    Math.sqrt(MAX_CANVAS_AREA / (pageSize.width * pageSize.height)),
    MAX_CANVAS_SIDE / Math.max(pageSize.width, pageSize.height)
  )
